module.exports = __webpack_public_path__ + "img/Inchcape_Flat_logo_Digi_Use_Horz_dk_blue_rgb_LR.19f969c7.png";